export type UserRole = 'family' | 'warrior' | 'angel' | 'admin';

export type Relationship = 'child' | 'mother' | 'father' | 'brother' | 'sister' | 'guardian' | 'other';

export const RELATIONSHIP_LABELS: Record<Relationship, string> = {
  child: 'Child',
  mother: 'Mother',
  father: 'Father',
  brother: 'Brother',
  sister: 'Sister',
  guardian: 'Guardian',
  other: 'Other',
};

export interface FamilyMember {
  id: string;
  name: string;
  relationship: Relationship;
  crmJourneyId?: string;
  // Plan 4.9 — CRM Family GUID. Same on every FamilyMember of a given
  // user; pick any one to call /families/:familyId/* endpoints.
  crmFamilyId?: string | null;
  // C7 — per-member photo permission (synced from CRM consent) + persistent
  // dietary requirement; surfaced on the register exports.
  photoPermission?: boolean;
  dietaryRequirements?: string | null;
  // Member personal-profile fields synced two-way with the CRM.
  interests?: string | null;
  favouriteFoodAndDrinks?: string | null;
  allergies?: string | null;
  // D8 — true when the family self-added this member via the App (fed from CRM
  // AddedViaFamilyApp). Drives the edit/remove affordance on the members screen.
  familyAdded?: boolean;
}

// Deprecated: Keep for backward compatibility
export interface Child extends FamilyMember {}

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  role: UserRole;
  familySize?: number;
  familyMembers?: FamilyMember[]; // Living members only — angels are segregated (see sanitizeUser)
  angelMembers?: FamilyMember[]; // Children who have passed away — counted in family size, never listed/selectable
  children?: FamilyMember[]; // Deprecated - use familyMembers
  photoPermission?: boolean;
  nameAndBirthdayPermission?: boolean;
  newsAndEventsPermission?: boolean;
  onlineActivitiesPermission?: boolean;
  createdAt: string;
  crmContactId?: string;
  // Volunteer fields
  isVolunteer?: boolean;
  volunteerStatus?: 'pending' | 'approved' | 'rejected' | 'revoked' | null;
  volunteerSince?: string;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  email: string;
  password: string;
  confirmPassword: string;
  firstName: string;
  lastName: string;
  phone?: string;
  familySize?: number;
}

export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}
